import services from "@/services/index.js";

export default {

    savePrescriptionDraft: async (body) => {
        return await services.postAsync({
            url: `/patients/prescriptions`,
            body,
            timeout: 10000,
            hasToken: true
        });
    },

    deletePrescriptionDraft: async (id, expectedRevision) => {
        return await services.postAsync({
            url: `/patients/prescriptions?deleted=true`,
            body: { id, expectedRevision },
            timeout: 10000,
            hasToken: true
        });
    },
    getPrescriptions: async (patientId, cursor, { encounterId = null, pagination = null } = {}) => {
        let url = `/patients/prescriptions?patientId=${encodeURIComponent(patientId)}`;
        if (cursor) {
            url += `&cursor=${encodeURIComponent(cursor)}`;
        }
        if (encounterId) url += `&encounterId=${encodeURIComponent(encounterId)}`;
        if (pagination) url += `&pagination=${encodeURIComponent(pagination)}`;
        return await services.getAsync({
            url,
            timeout: 20000,
            hasToken: true
        });
    },
    getPrescriptionById: async (prescriptionId) => {
        return await services.getAsync({
            url: `/patients/prescriptions?prescriptionId=${encodeURIComponent(prescriptionId)}`,
            timeout: 20000,
            hasToken: true
        });
    },
    generatePrescriptionFiles: async (body) => {
        return await services.postAsync({
            url: `/patients/prescriptions/files`,
            body: body,
            timeout: 20000,
            hasToken: true
        });
    },
    postPrescriptionShare: async (body) => {
        return await services.postAsync({
            url: `/patients/prescriptions/shares`,
            body: body,
            timeout: 20000,
            hasToken: true
        });
    },
    postSearchForPrescriptionAvailableItems: async (search, filter = "") => {
        return await services.postAsync({
            url: `/patients/prescriptions/searches`,
            body: {
                search,
                filter
            },
            timeout: 20000,
            hasToken: true
        });
    }
}
